<template>
  <div class="tabs-component pt-md-2 " id="top">
    <div class="tabs-component-panels">
      <div
        v-for="(tab, i) in tabs"
        :key="i"
        :class="tab.class"
        class="qa__box qa__box--big"
        v-show="tab.index == activeTabIndex"
      >
        <h3 v-html="tab.header" class="qa__title"></h3>
          <img  v-if='activeTabIndex == "pakiet-pszczelego-bohatera"'  src="../assets/images/pszczola1.jpg" class="qa__img mb-3" alt="Pakiet Pszczelego Bohatera">
        <div v-html="tab.content" class="qa__content"></div>
      </div>
    </div>
    <div class="tabs-component-tabs row">
      <router-link
        v-for="(tab, i) in tabs"
        :key="i"
        class="col-md-6 qa__links"
        :to="/pytania-i-odpowiedzi/ + tab.index"
        :id="tab.index"
        v-show="tab.isVisible"
      >
        <div :class="tab.class" class="qa__box qa__box--small qa__link ">
          <div v-html="tab.header" class="qa__headline"></div>
          <div class="qa__arrow">
            <font-awesome-icon :icon="['fas', 'chevron-right']" class="icon" />
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import json from "@/assets/qadata.json";

export default {
  data: () => ({
    tabs: json.data,
    activeTabIndex: 0,
  }),
  mounted() {
    this.activeTabIndex = this.$route.params.id;
    this.scrollToTop();
  
  },
  computed: {
    getFullPath() {
      return this.$route.path;
    },
  },

  methods: {
    getPageRefresh() {
      this.activeTabIndex = this.$route.params.id;
      setTimeout(() => {
        this.scrollToTop();
      }, 50);
    },
    scrollToTop() {
      const width = window.innerWidth;
      let heightOfForm = document.getElementById("form__wrapper").scrollHeight;
      if (width > 768) {
        window.scroll({
          top: 0,
          left: 0,
        });
      } else {
        window.scroll({
          top: heightOfForm,
          left: 0,
        });
      }
    },
  },
  watch: {
    getFullPath() {
      this.getPageRefresh();
    },
  },
};
</script>
